module.exports = __webpack_public_path__ + "img/icn_paper-list-accent.761264cb.svg";